module.exports = __webpack_public_path__ + "d0d05412c4839f1576d19c5722f70631.svg";